import type { AccountForChildEligibilityDetails } from '@generated-types';
import { useState } from 'react';
import { AccountApplicationContext, type AccountApplicationContextType } from './account-application-context';
import { AccountApplicationActions, type AccountApplicationActionsType } from './account-application-context-actions';

interface AccountApplicationContextProviderProps {
    children: React.ReactNode;
}

export const AccountApplicationContextProvider = ({ children }: AccountApplicationContextProviderProps) => {
    const [selectedChildEligibility, setSelectedChildEligibility] = useState<AccountForChildEligibilityDetails | null>(
        null,
    );
    const [applicantParentEmail, setApplicantParentEmail] = useState<string | null>(null);
    const [notifyApproverParentOnPhoneNumber, setNotifyApproverParentOnPhoneNumber] = useState<string | null>(null);
    const [applicantParentHasGivenConsent, setApplicantParentHasGivenConsent] = useState<boolean>(false);

    const childAccountContext: AccountApplicationContextType = {
        selectedChildEligibility,
        applicantParentEmail,
        notifyApproverParentOnPhoneNumber,
        applicantParentHasGivenConsent,
    };

    const childAccountActions: AccountApplicationActionsType = {
        setSelectedChildEligibility,
        setApplicantParentEmail,
        setNotifyApproverParentOnPhoneNumber,
        setApplicantParentHasGivenConsent,
    };

    return (
        <AccountApplicationContext.Provider value={childAccountContext}>
            <AccountApplicationActions.Provider value={childAccountActions}>
                {children}
            </AccountApplicationActions.Provider>
        </AccountApplicationContext.Provider>
    );
};
